import { fetchUsLv2AskBid } from 'apis/stock'
import mqtt, { mqttSub, mqttUnsub } from 'utils/mqtt'

const ARCA_EXCHANGE = 'quote-arca'

// 接口请求买卖盘
export default {
  data() {
    return {
      priceMap: {},
      askBidLoading: false,
      lastTimestamp: 0
    }
  },
  methods: {
    unsubAskBid(symbol) {
      if (this.hasUsLv2Permission) {
        mqttUnsub('askBidData', {
          name: 'quote',
          symbol,
          type: ARCA_EXCHANGE
        })
      } else {
        mqttUnsub('quoteTrade', {
          name: 'quote',
          symbol,
          type: 'trade'
        })
      }
    },
    subAskBid(symbol) {
      // FIXME 长连接暂时支持单个交易所
      if (!this.isUS || this.isOPT) return
      if (this.hasUsLv2Permission) {
        mqttSub('askBidData', {
          name: 'quote',
          symbol,
          type: ARCA_EXCHANGE
        })
      } else {
        // lv1买卖盘长连接，美股暂无lv0
        mqttSub('quoteTrade', {
          name: 'quote',
          symbol,
          type: 'trade'
        })
      }
    },
    subscribeQuotes() {
      mqtt.on('update.quote', this.handleQuoteUpdate, true)
    },
    unsubscribeQuotes() {
      mqtt.off('update.quote', this.handleQuoteUpdate)
    },
    handleQuoteUpdate({ topic, data }) {
      // 深度行情
      if (
        this.hasUsLv2Permission &&
        topic.indexOf(`quote/${this.symbol}/${ARCA_EXCHANGE}`) > -1 &&
        data.timestamp - this.lastTimestamp > 300
      ) {
        this.lastTimestamp = data.timestamp
        const askbid = {
          ask: this.formatDepthAskBid(JSON.parse(data.askDepth), 'ask'),
          bid: this.formatDepthAskBid(JSON.parse(data.bidDepth), 'bid')
        }
        this.buildPriceMap(askbid, false)
      }
      // 交易长连接
      if (
        topic.indexOf(`quote/${this.symbol}/trade`) > -1 &&
        data.timestamp - this.lastTimestamp > 300
      ) {
        const { askPrice, askSize, bidPrice, bidSize } = this.stock
        const askbid = {
          ask: [
            {
              price: data.askPrice || askPrice,
              volume: data.askSize || askSize
            }
          ],
          bid: [
            {
              price: data.bidPrice || bidPrice,
              volume: data.bidSize || bidSize
            }
          ]
        }
        this.buildPriceMap(askbid, false)
      }
    },
    formatDepthAskBid(arr, type) {
      const [prices, volumes] = arr
      return prices.map((price, index) => {
        return {
          type,
          price,
          volume: volumes[index]
        }
      })
    },
    getAskBidBySymbol(isResetPosition = true, isLoading = false) {
      if (this.isUS && this.hasUsLv2Permission && !this.isOPT) {
        this.askBidLoading = isLoading
        fetchUsLv2AskBid({
          symbol: this.symbol,
          props: 'askBidDepth'
        })
          .then(res => {
            // FIXME 目前只有arca的lv2
            if (res.ret === 0 && res.arca) {
              this.buildPriceMap(res.arca.askBidDepth, isResetPosition)
            } else {
              // 没有行情数据或没有权限，显示一档
              this.buildOneLevelPriceMap(isResetPosition)
            }
          })
          .finally(() => {
            this.askBidLoading = false
          })
      } else {
        // 非lv2从股票详情获取一档买卖盘数据
        this.buildOneLevelPriceMap(isResetPosition)
      }
    },
    buildPriceMap(askbid, isResetPosition) {
      if (!askbid) return
      const map = {
        latestPrice: this.priceMapLatestPrice
      }
      // 构建价格map，用于买卖盘判断指定价格是否有单子
      const {
        maxVolume: maxAskVolume,
        minPrice: minAskPrice
      } = this.getAskBidExtent(askbid.ask, 'ask', map)
      const {
        maxVolume: maxBidVolume,
        maxPrice: maxBidPrice
      } = this.getAskBidExtent(askbid.bid, 'bid', map)
      map.maxAskVolume = maxAskVolume
      map.maxBidVolume = maxBidVolume
      map.minAskPrice = minAskPrice
      map.maxBidPrice = maxBidPrice
      this.priceMap = map
      this.buildTableData(isResetPosition)
    },
    getAskBidExtent(arr = [], type, res) {
      let maxVolume = 0
      let maxPrice = 0
      let minPrice = Number.MAX_SAFE_INTEGER
      arr.forEach(el => {
        if (res[el.price]) {
          res[el.price].volume += el.volume
        } else {
          res[el.price] = { ...el, type }
        }
        maxVolume = Math.max(maxVolume, res[el.price].volume)
        maxPrice = Math.max(maxPrice, el.price)
        minPrice = Math.min(minPrice, el.price)
      })
      return { maxVolume, maxPrice, minPrice }
    },
    buildOneLevelPriceMap(isResetPosition) {
      const { askPrice, askSize, bidPrice, bidSize } = this.stock
      const askbid = {
        ask: [{ price: askPrice, volume: askSize }],
        bid: [{ price: bidPrice, volume: bidSize }]
      }
      // 港股lv0，美股没有lv0
      if (this.isHK && this.hasHkLv0Permission) {
        askbid.ask = []
        askbid.bid = []
      }
      this.buildPriceMap(askbid, isResetPosition)
    }
  }
}
